import { render } from "./NoResults.vue?vue&type=template&id=5906b3d4"
import script from "./NoResults.vue?vue&type=script&lang=js"
export * from "./NoResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/common/NoResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5906b3d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5906b3d4', __exports__)) {
    api.reload('5906b3d4', __exports__)
  }
  
  module.hot.accept("./NoResults.vue?vue&type=template&id=5906b3d4", () => {
    api.rerender('5906b3d4', render)
  })

}


export default __exports__